/**
 * Faster-checkout cart rendering — verbatim from v1 process_cart_page.js
 * UpdateCartElement (research/05 §5.3; REQ-CART-4). Preserved bugs: strict
 * element-count === item-count gate with the exact skip log; index-based
 * matching; the undefined `cartData` ReferenceError under Nova (§8.13 — see
 * the ambient declare below); the UNCONDITIONAL line-cost double-count
 * (cart_total_price += totalLineCost on every matched line, on top of the
 * already-priced cart total); the total rewritten INSIDE the loop reusing
 * `priceElement`; image `src` set on the container; and `textContent`
 * rendering literal `&pound;`/`&euro;` entities.
 *
 * `cartDataFromShopify` is the module-level cache written by the entry
 * (cart/entry.ts) on every /cart.js response, exactly where the v1 single
 * file assigned its module-scoped var.
 */
import $ from "jquery";
import { appState } from "../state/app-state";
import { IsNovaCurrencyCompatible, GetAmountAfterConversion } from "../currency";
import { CARTPAGE_formatPrice } from "./totals";

// [BUG-PARITY research/05 §8.13] — no runtime binding exists; the ambient
// declare keeps the port verbatim without emitting any binding, so the
// ReferenceError under Nova is preserved.
declare const cartData: any;

var cartDataFromShopify: any = [];

export function setCartDataFromShopify(cartData: any): void {
  cartDataFromShopify = cartData;
}

export async function UpdateCartElement(allVariantsFromCart: any, cpc_variantData: any): Promise<void> {
  let isNovaCurrencyCompatible = IsNovaCurrencyCompatible();

  if (appState.cpc_fasterCheckoutConfig === null) {
    console.log("faster checkout configuration not found for the store");
    return;
  }

  console.log("cartData", cartDataFromShopify);
  console.log("allVariantsFromCart", allVariantsFromCart);
  var cartPriceElements = document.querySelectorAll(appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig.itemPriceSelector);
  var totalPriceElement = document.querySelectorAll(appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig.totalPriceSelector);
  var cartItemTitleElements = document.querySelectorAll(appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig.titleSelector);
  var productImageElements = appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig.productImageSelector === null ? []
    : document.querySelectorAll(appState.cpc_fasterCheckoutConfig.fasterCheckoutConfig.productImageSelector);

  console.log("totalPriceElement", totalPriceElement);
  let cart_total_price = (cartDataFromShopify.total_price) / 100;

  if (isNovaCurrencyCompatible) {
    let user_curr = cartData.currency;
    let result = GetAmountAfterConversion(parseFloat(cart_total_price as any), user_curr, null);
    cart_total_price = result;
  }


  if (cartPriceElements.length === cartDataFromShopify.items.length) {
    //Update Cart Price
    cartPriceElements.forEach((priceElement: any, index: any) => {
      var elem = allVariantsFromCart.find(function (obj: any) { return obj.index === index; });
      if (elem === undefined) {
        console.log(`Skipping index ${index + 1}`);
        return;
      }

      var variantId = elem.item.variant_id;
      var cpcVariantInfo = cpc_variantData.find((a: any) => a.shopifyVariantId == variantId);
      if (cpcVariantInfo !== undefined) {

        //Update line item cost
        if (isNovaCurrencyCompatible) {
          let user_curr = cartData.currency;
          let result = GetAmountAfterConversion(parseFloat(cpcVariantInfo.amount), user_curr, null);
          cpcVariantInfo.amount = result;
        }
        var totalLineCost = cpcVariantInfo.amount * elem.item.quantity;
        cart_total_price += totalLineCost;
        //console.log('totalLineCost', totalLineCost)
        if (hasChildElements(priceElement)) {
          replaceCost(priceElement.children[0], totalLineCost);
          //console.log(`Element ${index + 1} contains child elements.`, priceElement.children[0]);
        } else {
          replaceCost(priceElement, totalLineCost);
          //console.log(`Element ${index + 1} does not contain child elements.`, priceElement);
        }

        //Update Product Title
        var titleElement = cartItemTitleElements.length > index ? cartItemTitleElements[index] : null;
        if (titleElement !== null && titleElement !== undefined) {
          if (hasChildElements(titleElement)) {
            replaceTextIfEmpty(titleElement.children[0], cpcVariantInfo.shopifyProductTitle);
            //console.log(`Element ${index + 1} contains child elements.`, titleElement.children[0]);
          } else {
            replaceTextIfEmpty(titleElement, cpcVariantInfo.shopifyProductTitle);
            //console.log(`Element ${index + 1} does not contain child elements.`, titleElement);
          }
        }

        //Update Product Image
        var productImage: any = productImageElements.length > index ? productImageElements[index] : null;
        if (productImage !== null && productImage !== undefined) {
          var imageElementHtml = $(productImage).html();
          if (imageElementHtml.includes("<img"))
            productImage.setAttribute("src", cpcVariantInfo.productImageUrl);
          else {
            //create image tag
            var imgElement = document.createElement("img");
            imgElement.src = cpcVariantInfo.productImageUrl;
            imgElement.width = 150;
            productImage.appendChild(imgElement);
          }
        }

        //Update total price
        if (totalPriceElement.length >= 1) {
          priceElement = totalPriceElement[0];
          if (hasChildElements(priceElement)) {
            replaceCost(priceElement.children[0], cart_total_price);
          } else {
            replaceCost(priceElement, cart_total_price);
          }
        }
      }
    });
  } else {
    console.log(`Skipping faster checkout as the selector doesn't match. Selector count: ${cartPriceElements.length}, Cart Item Count = ${cartDataFromShopify.items.length}`);
  }
}

function hasChildElements(element: any): boolean {
  return element.children.length > 0;
}

function replaceCost(container: any, cost: any): void {
  var formattedPrice = CARTPAGE_formatPrice(cartDataFromShopify.currency, cost);
  container.textContent = formattedPrice;
}

function replaceTextIfEmpty(container: any, newText: any): void {
  if (container.textContent.trim() === "")
    container.textContent = newText;
}
